import Registration from './registration'

function App() {
  return (
    <Registration/>
  );
}

export default App;
